import { getLocalStorage } from "../../../../../../../utils/crud/crypt"
import { Local } from "../formActivity/create/types"
import { images } from '../../../../../../../utils/images'
import { InputModel } from "../../../../../../../utils/types"


export const useInitialValues = () => {
  const state: Local = getLocalStorage()
  const companyId = state?.company?.id
  return {
    picture: {
      label: 'Cargar imagen',
      translate: true,
      name: 'picture',
      type: 'picture',
      value: null,
      rest: {
        customImage: images.store,
      },
      size: {
        xl: 5,
        lg: 5,
        md: 6,
        sm: 6,
      },
    },
    name: {
      label: 'general.tags.store_name',
      translate: true,
      customLabel: 'general.tags.store_name',
      name: 'name',
      validate: {
        required: true,
      },
      rest: {
        type: 'alphaNumeric',
        inputProps: {
          maxLength: 45,
        },
      },
      value: null,
    },
    email: {
      label: 'general.tags.email',
      translate: true,
      name: 'email',
      validate: {
        required: true,
        email: true,
      },
      value: null,
    },
    ...!companyId && {
      companyId: {
        label: 'general.tags.company',
        translate: true,
        name: 'companyId',
        validate: {
          required: true,
        },
        type: 'select-search',
        items: [],
        value: null,
      },
    },
    userManageId: {
      label: 'general.tags.userManageId',
      translate: true,
      name: 'userManageId',
      type: 'select-search',
      items: [],
      value: null,
    },
    score: {
      label: 'general.tags.score',
      translate: true,
      name: 'score',
      validate: {
        required: true,
        number: true,
      },
      rest: {
        type: 'number',
        min: 0,
        max: 100,
      },
      value: null,
    },
    phone: {
      label: 'general.tags.phone',
      translate: true,
      name: 'phone',
      type: 'phone',
      value: '+52',
      validate: {
        phone: true,
      },
    },
    states: {
      label: 'general.tags.states',
      translate: true,
      name: 'states',
      type: 'select-search',
      items: [],
      validate: {
        required: true,
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
      },
      value: null,
    },
    city: {
      label: 'general.tags.cities',
      translate: true,
      name: 'city',
      type: 'select-search',
      items: [],
      validate: {
        required: true,
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
      },
      value: null,
      customeErrors: {
        required: 'general.validate.required.cities',
      },
    },
    status: {
      label: 'general.tags.status',
      translate: true,
      name: 'status',
      type: 'select-search',
      validate: {
        required: true,
      },
      value: null,
    },
    address: {
      label: 'general.tags.address',
      translate: true,
      name: 'address',
      value: null,
      validate: {
        required: true,
      },
    },
    timeZone: {
      label: 'general.tags.timezone',
      translate: true,
      name: 'timeZone',
      type: 'select-search',
      items: [],
      value: null,
      validate: {
        required: true,
      },
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    latitude: {
      label: 'general.tags.latitude',
      translate: true,
      name: 'latitude',
      value: null,
      validate: {
        required: true,
      },
      rest: {
        type: 'chordenada',
      },
      size: {
        lg: 6,
      },
    },
    longitude: {
      label: 'general.tags.longitude',
      translate: true,
      name: 'longitude',
      validate: {
        required: true,
      },
      rest: {
        type: 'chordenada',
      },
      value: null,
      size: {
        lg: 6,
      },
    },
    keyCode: {
      label: 'general.tags.keyCode',
      translate: true,
      name: 'keyCode',
      validate: {
        required: true,
      },
      rest: {
        type: 'onlyNumberAndCharacter',
      },
      value: null,
    },
    divisions: {
      label: 'general.tags.divisions',
      translate: true,
      name: 'divisions',
      type: 'select-search',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    fatherZone: {
      label: 'general.tags.fatherZone',
      translate: true,
      name: 'fatherZone',
      type: 'select-search',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    class: {
      label: 'general.tags.class',
      translate: true,
      name: 'class',
      type: 'select-search',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
  } as { [x: string]: InputModel }
}

export const initialData = {
  name: null,
  email: null,
  companyId: null,
  zipCodeId: null,
  states: null,
  city: null,
  status: null,
  picture: null,
  phone: null,
  address: null,
  latitude: '0',
  longitude: '0',
  score: '0',
  userManageId: null,
  keyCode: null,
  divisions: null,
  fatherZone: null,
  class: null,
}
